import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'buttonLinkIcon' })
export class ButtonLinkIconPipe implements PipeTransform {
  transform(url: string): any {
    return this.isInternalURL(url) ? 'arrow_next' : 'external_link';
  }

  private isInternalURL(url: string): boolean {
    return url.startsWith('https://www.1jeune1solution');
  }
}

@NgModule({
  declarations: [ButtonLinkIconPipe],
  exports: [ButtonLinkIconPipe],
  providers: [ButtonLinkIconPipe],
  imports: [CommonModule],
})
export class ButtonLinkIconModule {}
